import { useEffect, useRef, useState } from "react";
import { HelloProduct } from "../types/backend";
import { API } from "../api/products";
import Tracker from "../HelloARTracker";

interface UseProductInput {
  id?: string;
  data?: HelloProduct;
}

const apiManager = new API();

const transformLegacyProductData = (data: HelloProduct): HelloProduct => {
  if (typeof data?.rendering_rules?.envMapMeta?.intensity === "number") {
    return {
      ...data,
      rendering_rules: {
        ...data.rendering_rules,
        envMapMeta: {
          ...data.rendering_rules.envMapMeta,
          intensity: (data.rendering_rules.envMapMeta.intensity * 60) / 100,
        },
      },
    };
  } else {
    return data;
  }
};

export const useProduct = ({ id, data }: UseProductInput) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [productData, setProductData] = useState<HelloProduct>();

  const currentlyLoadedProductId = useRef<string>();
  const currentlyLoadingProductId = useRef<string>();

  useEffect(() => {
    if (id) {
      if (currentlyLoadedProductId.current === id) {
        return;
      }
      if (currentlyLoadingProductId.current === id) {
        return;
      }
      const tracker = Tracker.getTracker();

      tracker?.startProductSession();

      currentlyLoadingProductId.current = id;
      apiManager
        .fetchProduct(id)
        .then((res) => {
          setProductData(res);
          currentlyLoadedProductId.current = res._id;
          setIsError(false);
          if (tracker) {
            const appId =
              typeof res.application === "string"
                ? res.application
                : res.application._id;
            tracker.curentProductSession?.requested(res._id, appId);
          }
        })
        .catch((err) => {
          setIsError(true);
          setErrorMessage("Error while fetching product from backend");
          console.error("Error while fetching product from backend", err);
        })
        .finally(() => {
          setIsLoading(false);
          currentlyLoadingProductId.current = undefined;
        });
    } else if (data) {
      // data._id = id ?? ""
      setProductData(data);
      currentlyLoadedProductId.current = data._id;
      setIsLoading(false);
      setIsError(false);
      const tracker = Tracker.getTracker();
      if (tracker) {
        // console.log(tracker, "tracker")
        // console.log(data.application, "app")
        // console.log(id, "id")
        // console.log(productData, "product")
        // console.log(data, "data")
        const appId =
          typeof data.application === "string"
            ? data.application
            : data.application?._id;
        tracker.curentProductSession?.requested(data?._id, appId);
      }
    } else {
      setIsError(true);
      setErrorMessage("Product Id or Product Data Not Provided");
    }
  }, [id, data]);

  return {
    isLoading: isLoading,
    isError: isError,
    error: errorMessage,
    data: productData ? transformLegacyProductData(productData) : undefined,
  };
};
